'use client';

import Header from '@/components/Header';
import ContactForm from '@/components/ContactForm';
import ContactInfo from '@/components/ContactInfo';

export default function Contact() {
    return (
        <>
            <Header />
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-16">
                {/* Hero Section */}
                <div className="container mx-auto px-4 py-16">
                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-4">
                        Contact Us
                    </h1>
                    <p className="text-gray-600 dark:text-gray-300 text-center max-w-2xl mx-auto">
                        Have questions about importing from China? Our team is here to help you navigate 
                        the process and find the best solutions for your business.
                    </p>
                </div>

                <div className="container mx-auto px-4 py-12">
                    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
}